export const environment = {
  production: true,
  version: 'ab87ea8ae4',
  site_version: 'SITE_VERSION'
};
